var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_695_4729)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 8.2V4C15.9999 3.4 15.5999 3 14.9999 3H10.7999C10.1999 3 9.7999 3.4 9.7999 4C9.7999 4.6 10.1999 5 10.7999 5H12.5999L11.2999 6.3L10.0999 7.5L7.9999 9.6L5.8999 7.4C5.3999 7 4.5999 7 4.0999 7.4L0.699902 10.8C0.299902 11.2 0.299902 11.8 0.699902 12.2C1.0999 12.6 1.6999 12.6 2.0999 12.2L4.9999 9.4L7.0999 11.5C7.5999 12 8.2999 12 8.7999 11.5L11.4999 9L12.6999 7.8L13.9999 6.4V8.2C13.9999 8.8 14.3999 9.2 14.9999 9.2C15.5999 9.2 15.9999 8.8 15.9999 8.2Z",
    fill: "#00DBB6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_695_4729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrow);
export default __webpack_public_path__ + "static/media/grow.4ddcd60c682f18ed79793875a1103a9e.svg";
export { ForwardRef as ReactComponent };